import { Badge } from 'framework/ui/mui-builder';
import React from 'react';

const RemainedDaysChip: React.FC<{ label: string }> = ({ label }) => (
  <Badge color="secondary" sx={{ fontSize: '14px' }}>
    {label}
  </Badge>
);

export default RemainedDaysChip;
